import { render, staticRenderFns } from "./EvalScalesSelect.vue?vue&type=template&id=0b53cde8"
import script from "./EvalScalesSelect.vue?vue&type=script&lang=js"
export * from "./EvalScalesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports